const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"feClose0\" fill=\"none\" fill-rule=\"evenodd\" stroke=\"none\" stroke-width=\"1\"><g id=\"feClose1\" fill=\"currentColor\"><path id=\"feClose2\" d=\"M10.657 12.071L5 6.414L6.414 5l5.657 5.657L17.728 5l1.414 1.414l-5.657 5.657l5.657 5.657l-1.414 1.414l-5.657-5.657l-5.657 5.657L5 17.728z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;
